import { Component, OnInit } from '@angular/core';
import {ReportsService} from '../reports/reports.service';
import { DomSanitizer } from '@angular/platform-browser';
import {LayersService} from '../_services/layers.service';
import {GlobalsService} from '../_services/globals.service';
import {TabledataService} from '../_services/tabledata.service';
import {LoginService} from '../login/login.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.css'],
    standalone: false
})

export class ReportsComponent implements OnInit {

    displayreports:boolean = false;   

    reporturl:any;
    sw:any = window.screen.width;
    sh:any = window.screen.height;  

    midparameter:any;
    obimeparameter:any;

    //vars for upload 
    showFilesDialog:boolean=false;
    uploadurl : string;
    docid:any;
    docyear:any;
    downloadFilesList:any[]=[];
    downloadFilesListFiltered:any = {};
    downloadFilesListFilteredKeys:any[] = [];
    noFiles:boolean = false;  
    canUpload:boolean;
    canDownload:boolean;
    canopenFileDialog:boolean;
    docTypes:any = [];
    selectedDocType:any;
    selectedValuesReport:string[] =[];
    isGeneratingReport: boolean = false;
    

    constructor(private rs:ReportsService,private sanitizer: DomSanitizer,private ls:LayersService,
        private gs:GlobalsService , private tableService:TabledataService, 
        private logins:LoginService, private messageService: MessageService) { 
        
    }
  
  
    //start upload
    public showUploadForm() {
        this.canUpload =  this.logins.isAuthorisedRole("upload") || this.logins.isAuthorisedRole("admin");
        this.canDownload = this.logins.isAuthorisedRole("download") || this.logins.isAuthorisedRole("admin");
        this.canopenFileDialog = this.canDownload || (this.logins.isAuthorisedRole("upload") || this.logins.isAuthorisedRole("admin")) ;
        this.docTypes = this.rs.getDocumentTypes();
        this.selectedDocType = this.docTypes[0].value;
        this.showFilesDialog=true;
        this.getFileList();
    }
  
  
    public onBeforeUploadFile(event) {
        
        this.docyear = this.selectedDocType;
        this.uploadurl =  this.gs.getRestUrl()+"/api/documents/upload?id=" +this.docid +"&docdir="+this.docyear;
        //console.log("on before Upload : doc type = "+this.uploadurl);
    }
  
    public onUploadFile(event) {
        //console.log("onUpload !");
        this.getFileList();
    }
  
    private  getFileList():void {
        
        this.downloadFilesList = [];
        this.noFiles = false;
        this.downloadFilesListFiltered = {};
        this.downloadFilesListFilteredKeys = [];
        this.tableService.getData(this.gs.getRestUrl()+"/api/documents/list?id="+ this.docid ,true).subscribe((d:any)=>
        {
            
            if (d.nodata)
            {
                
                this.noFiles = true;
            }
            else
            {
                
                for(let f of d)
                {
                    f.url = this.gs.getRestUrl()+"/api/documents/file?id="+f.id+"&name="+f.fileName+"&dir="+f.dir;
                    f.urlDelete = this.gs.getRestUrl()+"/api/documents/delete?id="+f.id+"&name="+f.fileName+"&dir="+f.dir;
                    this.downloadFilesList.push(f);
                    if (this.downloadFilesListFiltered[f.dir] === undefined)
                    {    
                        this.downloadFilesListFiltered[f.dir] = [];
                    }    
                    this.downloadFilesListFiltered[f.dir].push(f);
                }    
                
                
            }    
            this.showFilesDialog=true;
            this.downloadFilesListFilteredKeys =  Object.keys(this.downloadFilesListFiltered);
            //console.log(this.downloadFilesListFiltered);
        },e=>{console.log(e)});
    }
  
    public downloadFile(url) {
        this.tableService.getFile(url, true);
    }
    //end upload
    public deleteFile(url) {
        
        this.tableService.deleteFile(url, true).subscribe(r=>{
            this.getFileList();
        });
        
        
    }
  
    public checkMultiple(r,g,a) {
        //console.log(g);
        //console.log(a);
        var isRoot = r==g;
        
        
        if (this.selectedValuesReport.filter(v=>v === g ).length > 0 && isRoot)
        {    
            this.selectedValuesReport = this.selectedValuesReport.concat(a);
            
        }
        else if(this.selectedValuesReport.filter(v=>v === g ).length === 0 && isRoot)
        {
            
            this.selectedValuesReport = this.selectedValuesReport.filter(v=> !a.includes(v)  );
        }    
        else if(!isRoot && a.filter(v=>this.selectedValuesReport.find(r=>r==v) ).length == 0)
        {
            this.selectedValuesReport = this.selectedValuesReport.filter(v=> v!==r );
        }        
        else if(!isRoot && a.filter(v=>this.selectedValuesReport.find(r=>r==v) ).length > 0)
        {
            if (!this.selectedValuesReport.find(e=>e==r))
                this.selectedValuesReport = this.selectedValuesReport.concat(r);
        }        
                
    }
  
    public exportReport(format: string) {
        if (this.isGeneratingReport) {
            return;
        }

        let reportstoshow = '';
        if (this.selectedValuesReport.length > 0) {
            reportstoshow = this.selectedValuesReport.join();
        }

        this.isGeneratingReport = true;
        this.rs.setGeneratingReport(true);
        this.displayreports = false;

        this.messageService.clear('reports');

        this.messageService.add({
            key: 'reports',
            severity: 'info',
            summary: 'Obvestilo',
            detail: 'Poročilo v izdelavi, prosimo počakajte ...',
            sticky: true
        });

        this.rs.exportFile(
            'ELEK_knjiga',
            format,
            'userLocale=de&reportLocale=de&ob_ime=' +
            this.replaceAll(this.obimeparameter, ' ', '+') +
            '&ob_mid=' + this.midparameter +
            '&showreports=' + reportstoshow
        ).subscribe(
            d => {
                this.messageService.clear('reports');

                this.messageService.add({
                    key: 'reports',
                    severity: 'success',
                    summary: 'Obvestilo',
                    detail: 'Poročilo izdelano ...',
                    life: 3000
                });

                this.rs.downloadFile(d, 'ELEK_knjiga_' + this.obimeparameter + '.' + format, format);

                setTimeout(() => {
                    this.isGeneratingReport = false;
                    this.rs.setGeneratingReport(false);
                }, 3000);
            },
            e => {
                this.messageService.clear('reports');
                this.messageService.add({
                    key: 'reports',
                    severity: 'error',
                    summary: 'Obvestilo',
                    detail: 'Napaka: ' + e,
                    life: 4000
                });

                this.isGeneratingReport = false;
                this.rs.setGeneratingReport(false);
            }
        );
    }
  
    private replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
  
    ngOnInit() {
        this.rs.subscribeOpenReportComponent().subscribe(
            f => {
                if (this.isGeneratingReport) {
                    return;
                }
                this.displayreports = true;
                console.log("open reports");
            },
            e => { console.log(e); },
            () => { console.log("done open report"); }
        );

        this.ls.subscribeLayersGroupLoadListener().subscribe(
            data => {
                if (data.ob_mid !== undefined) {
                    this.displayreports = false;
                    this.midparameter = data.ob_mid;
                    this.obimeparameter = data.ob_uime;
                    this.docid = this.midparameter + "_letno_porocilo";
                } else {
                    console.log("load layer group error: data undefined ");
                }
            },
            err => { console.log(err); }
        );
    }

}
